
<!-- TemplateBeginEditable name="hero" -->
<div class="dcf-hero dcf-hero-default">
  <!-- TemplateEndEditable -->
  <div class="dcf-hero-group-1">
    <div class="dcf-breadcrumbs-wrapper">
      <nav class="dcf-breadcrumbs" id="dcf-breadcrumbs" role="navigation" aria-label="breadcrumbs">
        <!-- TemplateBeginEditable name="breadcrumbs" -->
        <ol>
          <li><a href="https://www.unl.edu/">Nebraska</a></li>
          <li><a href="/">TCAN / VITA Lincoln</a></li>
          <li><a href="/management">Management</a></li>
          <li><span aria-current="page">User Management</span></li>
        </ol>
        <!-- TemplateEndEditable -->
      </nav>
    </div>
    <header class="dcf-page-title" id="dcf-page-title">
      <!-- TemplateBeginEditable name="pagetitle" -->
      <h1>User Management</h1>
      <!-- TemplateEndEditable -->
    </header>
    <!-- TemplateBeginEditable name="herogroup1" -->
    <!-- TemplateEndEditable -->
  </div>
  <!-- TemplateBeginEditable name="herogroup2" -->
  <div class="dcf-hero-group-2">
  </div>
  <!-- TemplateEndEditable -->
</div>
<div class="dcf-main-content dcf-wrapper">
  <!-- TemplateBeginEditable name="maincontentarea" -->
  <div class="dcf-bleed">
    <div class="dcf-wrapper">
      <button id="add-user" (click)="openDialog()">Add User</button>
      <!-- <a class="dcf-btn dcf-btn-primary dcf-float-right dcf-mb-5" id="add-user" href="#add-user-modal">Add User</a> -->
    </div>
    <div class="dcf-wrapper dcf-mb-8" id="user-management-table-row">
      <table class="table table-condensed table-hover dcf-table dcf-table-striped" id="user-management-table">
        <thead><tr><th>Name</th><th>Email</th><th>Permissions</th><th>Edit</th></tr></thead>
        <tbody>
          @for (user of users; track user) {
            <tr key="user.id">
              <th data-header="Name">{{ user.firstName + " " + user.lastName }}</th>
              <td data-header="Email">{{ user.email }}</td>
              <td data-header='Permissions'>
                <ul>
                  @for (permission of user.permissions; track permission) {
                    <li [value]="permission.permissionId" [hidden]="permission.userPermissionId === null || permission.userPermissionId == false"> {{ permission.name }}</li>
                  }
                </ul>
                <button (click)="editPermissions(user)">
                  Edit Permissions
                </button>
              </td>
              <td data-header='Edit'><a (click)="editUser(user)" class='userEditButton'>Edit</a></td>
            </tr>
          }
        </tbody>
      </table>
    </div>
  </div>
  <!-- End Edit User Modal -->


  <!-- TemplateEndEditable -->
</div>